<!-- 汇率维护 -->
<template>
  <div class="exchangerateMaintain">
    <div class="main-content">
      <vxe-toolbar style="margin: 0 0 10px 0">
        <template v-slot:buttons>
          <template v-for="item in menuButtonList">
            <vxe-button
              type="primary"
              :icon="item.attributes.buttonStyle"
              :style="
                'background-color:' +
                (item.label == '删除' || item.label == '禁用' ? '#FE8783' : '#00b400') +
                ';border:1px solid ' +
                (item.label == '删除' || item.label == '禁用' ? '#FE8783' : '00b400')
              "
              :key="item.id"
              @click="chooseClick(item.attributes.buttonUrl, item)"
              >{{ item.label }}</vxe-button
            >
          </template>
        </template>
      </vxe-toolbar>
      <vxe-grid
        border
        show-overflow
        resizable
        ref="table"
        class="vxe-table-element"
        size="mini"
        align="left"
        min-width="120"
        :loading="loading"
        :edit-actived="activeIndex"
        :auto-resize="true"
        :data="tableData"
        :edit-rules="rules"
        :edit-config="{ trigger: 'click', mode: 'row' }"
        @cell-click="getActiveIndex"
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
      >
        <vxe-table-column type="checkbox" width="50"></vxe-table-column>
        <!-- 币种 自 -->
        <vxe-table-column
          field="fromCurrencyCode"
          :title="$t('exchangerate.label.fromCurrencyCode')"
          :edit-render="{ type: 'visible' }"
        >
          <template v-slot:edit="scope">
            <el-select
              filterable
              clearable
              v-model="scope.row.fromCurrencyCode"
              :placeholder="$t('exchangerate.placeholder.fromCurrencyCode')"
              @change="fromCurrencyCodeChange(scope)"
            >
              <el-option
                v-for="item in currencyList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
        </vxe-table-column>
        <!-- 币种 至 -->
        <vxe-table-column
          field="toCurrencyCode"
          :title="$t('exchangerate.label.toCurrencyCode')"
          :edit-render="{ type: 'visible' }"
        >
          <template v-slot:edit="scope">
            <el-select
              filterable
              clearable
              v-model="scope.row.toCurrencyCode"
              :placeholder="$t('exchangerate.placeholder.toCurrencyCode')"
              @change="toCurrencyCodeChange(scope)"
            >
              <el-option
                v-for="item in currencyList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
        </vxe-table-column>
        <!-- 起始日期 -->
        <vxe-table-column
          field="startTime"
          :title="$t('exchangerate.label.startTime')"
          :edit-render="{ type: 'visible' }"
        >
          <template v-slot:edit="{ row, rowIndex }">
            <el-date-picker
              style="width: 100%"
              clearable
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="$t('exchangerate.placeholder.startTime')"
              :picker-options="pickerStartOptions"
              v-model="row.startTime"
              @focus="setActiveIndex(rowIndex)"
            ></el-date-picker>
          </template>
          <template v-slot="scope">{{ formatDate(scope.row.startTime, 'yyyy/MM/dd') }}</template>
        </vxe-table-column>
        <!-- 终止日期 -->
        <vxe-table-column
          field="endTime"
          :title="$t('exchangerate.label.endTime')"
          :edit-render="{ type: 'visible' }"
        >
          <template v-slot:edit="{ row, rowIndex }">
            <el-date-picker
              style="width: 100%"
              clearable
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="$t('exchangerate.placeholder.endTime')"
              :picker-options="pickerEndOptions"
              v-model="row.endTime"
              @focus="setActiveIndex(rowIndex)"
            ></el-date-picker>
          </template>
        </vxe-table-column>
        <!-- 汇率类型 -->
        <vxe-table-column
          field="exchangeType"
          :title="$t('exchangerate.label.exchangeType')"
          :edit-render="{ type: 'visible' }"
        >
          <template v-slot:edit="scope">
            <el-select
              filterable
              clearable
              :placeholder="$t('exchangerate.placeholder.exchangeType')"
              v-model="scope.row.exchangeType"
              @change="$refs.table.updateStatus(scope)"
            >
              <el-option
                v-for="item in exchangeTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
        </vxe-table-column>
        <!-- 币种自->币种至 -->
        <vxe-table-column
          field="positiveRate"
          :title="$t('exchangerate.label.positiveRate')"
          :edit-render="{ type: 'visible' }"
        >
          <template v-slot:edit="{ row, rowIndex }">
            <el-input-number
              style="width: 100%"
              :precision="$globalVar.ePiont"
              :controls="false"
              :min="0"
              :placeholder="$t('exchangerate.placeholder.positiveRate')"
              v-model="row.positiveRate"
              @change="positiveRateChange(row.positiveRate, rowIndex)"
            ></el-input-number>
          </template>
        </vxe-table-column>
        <!-- 币种至->币种自 -->
        <vxe-table-column
          field="negativeRate"
          :title="$t('exchangerate.label.negativeRate')"
          :edit-render="{ type: 'visible' }"
        >
          <template v-slot:edit="{ row, rowIndex }">
            <el-input-number
              style="width: 100%"
              :precision="$globalVar.ePiont"
              :controls="false"
              :min="0"
              :placeholder="$t('exchangerate.placeholder.negativeRate')"
              v-model="row.negativeRate"
              @change="negativeRateChange(row.negativeRate, rowIndex)"
            ></el-input-number>
          </template>
        </vxe-table-column>
      </vxe-grid>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { addRules } from './rules.js'; // 校验规则
  import API from '@/api/financeCenter/exchangerate';
  import XEUtils from 'xe-utils';
  export default {
    name: 'exchangerateMaintain',
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
    },
    data() {
      return {
        currencyList: [], // 币种数据
        exchangeTypeList: [],
        menuButtonList: [],
        tableData: [], // 表格数据
        rules: addRules, // 校验规则
        loading: false,
        activeIndex: null,
        addRowObj: {
          fromCurrencyCode: '',
          toCurrencyCode: '',
          exchangeType: '',
          startTime: '',
          endTime: '',
          positiveRate: undefined,
          negativeRate: undefined,
        },
        pickerStartOptions: {
          disabledDate: (time) => {
            if (this.tableData[this.activeIndex] && this.tableData[this.activeIndex].endTime) {
              return time.getTime() >= new Date(this.tableData[this.activeIndex].endTime).getTime();
            }
          },
        },
        pickerEndOptions: {
          disabledDate: (time) => {
            if (this.tableData[this.activeIndex] && this.tableData[this.activeIndex].startTime) {
              return (
                time.getTime() <=
                new Date(this.tableData[this.activeIndex].startTime).getTime() - 3600 * 24 * 1000
              );
            }
          },
        },
      };
    },
    mounted() {
      this.getCurrency();
      this.getDictList();
      this.resolveTableData(); // 初始五行表格空数据
      this.$nextTick(() => {
        this.getButtonList();
      });
    },
    methods: {
      chooseClick(value) {
        if (value === 'add') {
          this.handleAdd();
        } else if (value === 'del') {
          this.handleDelete();
        } else if (value === 'cancel') {
          this.handleCancel();
        } else if (value === 'save') {
          this.handleSave();
        }
      },
      // 新增
      handleAdd() {
        this.tableData.push(JSON.parse(JSON.stringify(this.addRowObj)));
      },
      // 删除
      handleDelete() {
        const selectedList = this.$refs.table.getSelectRecords(); // 或许选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('outsidePrice.message.noData'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            this.$refs.table.removeSelecteds().then(() => {
              this.tableData = this.$refs.table.getTableData().fullData;
            });
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('cooperation.message.deleteSuccess'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: '已取消',
            });
          });
      },
      // 取消
      handleCancel() {
        this.$confirmAction(
          this.$t('exchangerate.message.cancel_save_data'),
          this.$t('exchangerate.message.is_sure')
        )
          .then(() => {
            this.returnListPage();
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('exchangerate.message.cancelled'),
            });
          });
      },
      // 保存
      handleSave() {
        if (this.tableData.length === 0) {
          this.$message({
            showClose: true,
            message: this.$t('exchangerate.message.no_Data'),
            type: 'error',
          });
          return;
        }
        this.$refs.table.validate().then(() => {
          const createBy = this.userInfo.userCode;
          const { tenantCode, companyCode, departmentCode, companyName, departmentName } =
            this.userInfo;
          const currencyExchangeString = JSON.stringify(this.tableData);
          const params = {
            createBy,
            currencyExchangeString,
            tenantCode,
            companyCode,
            departmentCode,
            companyName,
            departmentName,
          };
          this.$axios.post(API.EXCHANGERATE_ADD_LIST, params).then((res) => {
            if (res.data.code === 0) {
              this.$message({ showClose: true, message: res.data.msg, type: 'success' });
              this.returnListPage(); // 返回列表页
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          });
        });
      },
      // 币种自改变
      fromCurrencyCodeChange(scope) {
        this.$refs.table.updateStatus(scope);
        let { fromCurrencyCode, toCurrencyCode } = this.tableData[scope.rowIndex];
        if (toCurrencyCode && fromCurrencyCode == toCurrencyCode) {
          this.$message({
            showClose: true,
            message: this.$t('exchangerate.message.repeat'),
            type: 'error',
          });
          this.tableData[scope.rowIndex].fromCurrencyCode = '';
        }
      },
      // 币种至改变
      toCurrencyCodeChange(scope) {
        this.$refs.table.updateStatus(scope);
        let { fromCurrencyCode, toCurrencyCode } = this.tableData[scope.rowIndex];
        if (fromCurrencyCode && toCurrencyCode == fromCurrencyCode) {
          this.$message({
            showClose: true,
            message: this.$t('exchangerate.message.repeat'),
            type: 'error',
          });
          this.tableData[scope.rowIndex].toCurrencyCode = '';
        }
      },
      // 获取当前激活行索引
      getActiveIndex(value) {
        this.activeIndex = value.rowIndex;
      },
      // 日期获得焦点 => 避免日期校验拿不到activeIndex值
      setActiveIndex(index) {
        this.activeIndex = index;
      },
      // 选中事件
      handleSelectionChange(val) {
        this.multipleSelection = val.selection;
      },
      // 正向汇率改变
      positiveRateChange(value, index) {
        this.tableData[index].negativeRate = 1 / value;
      },
      // 逆向汇率改变
      negativeRateChange(value, index) {
        this.tableData[index].positiveRate = 1 / value;
      },
      //币别
      async getCurrency() {
        let res = await this.$baseRequest.getCurrency();
        if (res) {
          this.currencyList = res;
          this.currencyList = this.currencyList.map((item) => {
            return {
              value: item.currencyCode,
              label: item.currencyName,
            };
          });
        }
      },
      // 获取字典值
      getDictList() {
        const tenantCode = this.userInfo.tenantCode; // 租户编码
        // 汇率类型
        this.$axios.post(API.DICT_LIST, { dictType: 'exchange_type', tenantCode }).then((res) => {
          if (res.data.code === 0) {
            this.exchangeTypeList = res.data.data;
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      //获取菜单按钮
      getButtonList() {
        this.menuButtonList = [
          {
            label: '新增',
            attributes: {
              buttonUrl: 'add',
              buttonStyle: 'el-icon-plus',
            },
          },
          {
            label: '删除',
            attributes: {
              buttonUrl: 'del',
              buttonStyle: 'el-icon-delete',
            },
          },
          {
            label: '取消',
            attributes: {
              buttonUrl: 'cancel',
              buttonStyle: 'el-icon-close',
            },
          },
          {
            label: '保存',
            attributes: {
              buttonUrl: 'save',
              buttonStyle: 'el-icon-plus',
            },
          },
        ];
        // this.getButtons().then(res => {
        //   this.menuButtonList = res;
        // });
      },
      // 初始五行表格空数据,20200713改为默认1条。
      resolveTableData() {
        for (var i = 0; i < 1; i++) {
          this.tableData.push(JSON.parse(JSON.stringify(this.addRowObj)));
        }
      },
      // 编辑表格回显方法（回显label）
      getSelectLabel(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
      // 编辑表格回显方法（回显Value）
      getSelectValue(value, list, valueProp = 'value') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[valueProp] : null;
      },
      // 编辑表格回显方法（回显日期）
      formatDate(value, format) {
        return XEUtils.toDateString(value, format);
      },
      // 返回列表页
      returnListPage() {
        let path = {
          fromPath: {
            path: '/generalAccounting/exchangerateMaintain',
            name: 'exchangerateMaintain',
            meta: {
              keepAlive: true,
            },
          },
          toPath: {
            path: '/generalAccounting/exchangeRate',
            name: 'exchangeRate',
            meta: {
              keepAlive: false,
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
    },
  };
</script>

<style scoped></style>
